import cx from 'classnames';
import { Link } from 'gatsby';
import React from 'react';

import { COLORS } from '../../constants/colors';
import { useViewport } from '../../hooks';
import ArrowLeft from '../Global/ArrowLeft';
import ArrowLongLeft from '../Global/ArrowLongLeft';

const PartnershipsBackButton = ({ backgroundColor, color, open }) => {
  const viewport = useViewport();
  const isMobile = viewport !== 'desktop';
  const baseStyles =
    color && backgroundColor && !open ? { backgroundColor, color } : null;
  const arrowStyles = !open && color ? color : COLORS.licorice;
  return (
    <div className="partnerships-back-button">
      {isMobile ? (
        <Link
          className="partnerships-back-button__circle"
          style={baseStyles}
          to="/"
        >
          <ArrowLeft color={arrowStyles} />
        </Link>
      ) : (
        <Link
          className={cx('partnerships-back-button__pill', { open })}
          style={baseStyles}
          to="/"
        >
          <ArrowLongLeft color={arrowStyles} />
          Main Site
        </Link>
      )}
    </div>
  );
};

export default PartnershipsBackButton;
